module.exports = __webpack_public_path__ + "static/media/union.c2ac0893.png";